export const widgets = {
  // App — авторизация в Telegram WebApp
  "components.App.telegramAuth.loading": "Авторизация через Telegram...",
  "components.App.telegramAuth.error":
    "Не удалось авторизоваться в Telegram WebApp",

  // Переключатель темы
  "components.atoms.Toggle.light": "Светлая",
  "components.atoms.Toggle.dark": "Тёмная",
  "components.atoms.Toggle.switchToLight": "Переключить на светлую тему",
  "components.atoms.Toggle.switchToDark": "Переключить на тёмную тему",

  // Календарь: названия месяцев в шапке
  "components.atoms.Calendar.month.1": "Январь",
  "components.atoms.Calendar.month.2": "Февраль",
  "components.atoms.Calendar.month.3": "Март",
  "components.atoms.Calendar.month.4": "Апрель",
  "components.atoms.Calendar.month.5": "Май",
  "components.atoms.Calendar.month.6": "Июнь",
  "components.atoms.Calendar.month.7": "Июль",
  "components.atoms.Calendar.month.8": "Август",
  "components.atoms.Calendar.month.9": "Сентябрь",
  "components.atoms.Calendar.month.10": "Октябрь",
  "components.atoms.Calendar.month.11": "Ноябрь",
  "components.atoms.Calendar.month.12": "Декабрь",

  // Заглушки заголовка события (когда бэкенд не прислал title)
  "components.molecules.EventDetailInfo.titleFallback":
    "Получит ли награду Адам Кадыров в октябре 2024 года",
  "components.organisms.BettingCard.titleFallback":
    "Получит ли награду Адам Кадыров в октябре 2024 года",

  // Карточка события: объём торгов
  "components.molecules.FavoriteCard.amount": "{amount} тыс.",

  // Экран падения приложения
  "components.organisms.ErrorBoundary.title": "Что-то пошло не так",
  "components.organisms.ErrorBoundary.description":
    "Не удалось отобразить страницу. Попробуйте вернуться на главную — это обычно решает проблему.",
  "components.organisms.ErrorBoundary.button": "На главную",

  // Подписи линий графика (видны в тултипе)
  "components.organisms.Chart.series.yes": "ДА",
  "components.organisms.Chart.series.no": "НЕТ",

  // Обучающая модалка. ВАЖНО: вёрстка позиционируется абсолютными координатами
  // и ограничена шириной картинки — перевод держим не длиннее оригинала.
  "components.organisms.OnboardingModal.step1.title": "Выбери рынок",
  "components.organisms.OnboardingModal.step1.text":
    "Это биржа прогнозов, где участники сами создают рынки и участвуют в их ценообразовании. Торгуйте события из сотен категорий, от Финансов до Медиа",
  "components.organisms.OnboardingModal.step2.title": "Сделай прогноз",
  "components.organisms.OnboardingModal.step2.line1":
    "Пополни вступительный взнос через",
  "components.organisms.OnboardingModal.step2.line2":
    "депозит любым платежным методом.",
  "components.organisms.OnboardingModal.step2.line3":
    'Вернись к выбранному рынку и выбери "Да"',
  "components.organisms.OnboardingModal.step2.line4":
    'или "Нет" на основе своего прогноза',
  "components.organisms.OnboardingModal.step3.title": "Получай прибыль",
  "components.organisms.OnboardingModal.step3.text":
    "Дождитесь пока завершится событие, к\u00A0которому привязан рынок. После этого выплата поступит на ваш баланс",

  // Промокод: экран «применён»
  "components.organisms.PromoCodeModal.applied.title": "Промокод применён",
  "components.organisms.PromoCodeModal.applied.text":
    "Пополните на сумму от {minDeposit} ₸ и получите бонус {bonus} ₸",
  "components.organisms.PromoCodeModal.applied.button": "Понятно",

  // Подсказка «как это работает» на карточке ставки
  "components.organisms.QuestionModal.title":
    "Покупай токены - получай прoфит!",
  "components.organisms.QuestionModal.text":
    "Цена токена отражает вероятность наступления выбранного исхода. Введи сумму покупки в пределах максимальной и нажми «Подтвердить». Если событие завершится твоим исходом - ты получишь указанную выплату.",

  // Реферальная программа: копирование промокода
  "components.organisms.ReferalInfo.copy.success": "Промокод скопирован",
  "components.organisms.ReferalInfo.copy.error": "Не удалось скопировать",

  // Ставка: выбранный исход в шапке модалки
  "components.organisms.BettingModal.choice": "Выбор: {value}",
  "components.organisms.BettingModal.choice.yes": "Да",
  "components.organisms.BettingModal.choice.no": "Нет",

  // Ставка: исход не выбран (тост)
  "components.organisms.BettingCard.chooseOutcomeToast": "Выберите исход",

  // График: история сделок пуста
  "utils.charts.noBets": "Ставок пока нет",

  // Тексты уведомлений слоя запросов
  "queries.common.error": "Произошла ошибка",
  "queries.useCreateBet.priceChanged":
    "Цена изменилась с {expectedPrice} до {currentPrice}. Данные обновлены, попробуйте снова.",
  "queries.useCreateWallet.error": "Ошибка создания кошелька. Попробуйте позже.",
  "queries.useCreateWithdrawal.success": "Заявка на вывод создана",
  "queries.useCreateWithdrawal.error": "Ошибка создания вывода",
};
